export default "__VITE_ASSET__Dfnh2cgR__"